import { FC } from 'react'

import { Link } from 'components/links'
import { routes } from 'utils/routes'

import classes from './registration-link.module.css'

interface RegistrationLinkProps {
  className?: string
}

export const RegistrationLink: FC<RegistrationLinkProps> = ({ className }) => {
  return (
    <div className={classes.additionalInfo}>
      Not registered yet?{' '}
      <Link href={routes.partnerPortalRegistration} className={classes.link} theme="primaryLight">
        Create an account
      </Link>
    </div>
  )
}
